import type { SVGProps } from 'react';
import * as React from 'react';

const SvgGlobe16 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M14.166 8a6.1 6.1 0 0 1-1.52 4.047 6.1 6.1 0 0 1-3.76 2.046A5.5 5.5 0 0 1 8 14.16c-.307 0-.594-.02-.887-.067a6.1 6.1 0 0 1-3.76-2.046A6.1 6.1 0 0 1 1.833 8c0-1.547.573-2.973 1.52-4.047a6.1 6.1 0 0 1 3.76-2.046q.428-.069.887-.067c.306 0 .593.02.886.067a6.1 6.1 0 0 1 3.76 2.046A6.1 6.1 0 0 1 14.166 8"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M7.78 14.1c-.427-.447-2.447-2.653-2.447-6.1s2.02-5.653 2.447-6.1M8.22 14.1c.426-.447 2.446-2.653 2.446-6.1S8.646 2.347 8.22 1.9M1.833 8h12.333"
    />
  </svg>
);
export default SvgGlobe16;
